<template>
  <div class="Information">
    <div class="msg_css">
      <!-- 左侧列表：参考 ce.html 结构 -->
      <div class="msg_left">
        <div class="left_tabs">
          <div
            v-for="tab in tabs"
            :key="tab.name"
            class="tab_item"
            :class="{ active: activeName === tab.name }"
            @click="switchTab(tab.name)"
          >
            <span class="tab_label">{{ tab.label }}</span>
            <span v-if="tab.count > 0" class="tab_badge">{{
              tab.count > 99 ? "99+" : tab.count
            }}</span>
          </div>
        </div>

        <div class="left_list" v-loading="loading" @scroll="handleScroll">
          <div
            v-for="(item, index) in messageData"
            :key="item.id || index"
            class="left_li"
            :class="{
              is_active_: msg_id == item.id && !isMsgLocked(item),
              is_locked: isMsgLocked(item),
              is_deleted: isDeleted(item),
            }"
            @click="changeMsg(item)"
            @contextmenu.prevent="openContextMenu($event, item, index)"
          >
            <div class="li_img" :class="'icon_' + getMsgCategory(item)">
              <!-- 活动：礼物图标（对齐设计稿） -->
              <svg
                v-if="getMsgCategory(item) === 'activity'"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.3333 5.33331H2.66667C2.29848 5.33331 2 5.63179 2 5.99998V7.33331C2 7.7015 2.29848 7.99998 2.66667 7.99998H13.3333C13.7015 7.99998 14 7.7015 14 7.33331V5.99998C14 5.63179 13.7015 5.33331 13.3333 5.33331Z"
                  stroke="white"
                  stroke-width="1.33"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M8 5.33331V14"
                  stroke="white"
                  stroke-width="1.33"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M12.6667 8V12.6667C12.6667 13.0203 12.5262 13.3594 12.2762 13.6095C12.0261 13.8595 11.687 14 11.3334 14H4.66671C4.31309 14 3.97395 13.8595 3.7239 13.6095C3.47385 13.3594 3.33337 13.0203 3.33337 12.6667V8"
                  stroke="white"
                  stroke-width="1.33"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M5.00004 5.33332C4.55801 5.33332 4.13409 5.15772 3.82153 4.84516C3.50897 4.5326 3.33337 4.10868 3.33337 3.66665C3.33337 3.22463 3.50897 2.8007 3.82153 2.48814C4.13409 2.17558 4.55801 1.99999 5.00004 1.99999C5.64316 1.98878 6.27339 2.30083 6.80853 2.89543C7.34367 3.49003 7.75889 4.33959 8.00004 5.33332C8.24119 4.33959 8.65641 3.49003 9.19155 2.89543C9.72669 2.30083 10.3569 1.98878 11 1.99999C11.4421 1.99999 11.866 2.17558 12.1786 2.48814C12.4911 2.8007 12.6667 3.22463 12.6667 3.66665C12.6667 4.10868 12.4911 4.5326 12.1786 4.84516C11.866 5.15772 11.4421 5.33332 11 5.33332"
                  stroke="white"
                  stroke-width="1.33"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <i v-else :class="getMsgIcon(item)"></i>
            </div>
            <div class="li_box">
              <div class="li_box_top">
                <div class="top_tit">
                  <span class="tit_text">{{ getMsgTitle(item) }}</span>
                  <span v-if="isDeleted(item)" class="msg_state is_deleted">已删除</span>
                  <span v-if="isUnread(item) && !isMsgLocked(item)" class="unread_dot"></span>
                </div>
                <div class="top_date">{{ getDetailTime(item) }}</div>
              </div>
              <div class="li_box_con">{{ getMsgSnippet(item) }}</div>
            </div>
          </div>

          <div v-if="!loading && messageData.length === 0" class="list_empty">
            暂无消息
          </div>
          <div v-if="loadingMore" class="list_loading">加载中...</div>
          <div
            v-if="!hasMore && messageData.length > 0"
            class="list_loading"
          >
            没有更多了
          </div>
        </div>
      </div>

      <!-- 右侧详情：参考 ce.html 卡片结构 -->
      <div
        class="msg_right"
        :class="{ msg_right_empty: !msgData.id }"
        v-loading="detailLoading"
      >
        <template v-if="msgData.id">
          <!-- 已撤回：不调详情接口，展示空状态（对齐小程序 mesDetail） -->
          <div v-if="isRecalled(msgData)" class="removed_empty">
            <div class="removed_empty__icon-wrap">
              <i class="el-icon-warning-outline removed_empty__icon"></i>
            </div>
            <p class="removed_empty__text">该内容已被发布者删除</p>
          </div>
          <template v-else>
            <div class="right_time">{{ getDetailTime(msgData) }}</div>
            <div class="right_card">
              <div
                class="right_tit"
                :class="'tit_' + getMsgCategory(msgData)"
              >
                {{ getMsgTitle(msgData) }}
              </div>
              <div class="right_body">
                <div class="right_con">
                  <template v-if="detailBlocks.length">
                    <div
                      v-for="(block, bi) in detailBlocks"
                      :key="bi"
                      class="content_block"
                    >
                      <img
                        v-if="block.type === 'image'"
                        class="content_img"
                        :src="block.url || block.value"
                        alt="消息图片"
                      />
                      <div
                        v-else
                        class="content_text"
                        v-html="block.value"
                      ></div>
                    </div>
                  </template>
                  <div
                    v-else
                    class="content_text"
                    v-html="fallbackDetailHtml"
                  ></div>
                </div>
                <div class="right_sign">
                  ——{{ msgData.signature || msgData.sign || "青梨 AI 团队" }}
                </div>
              </div>
            </div>
          </template>
        </template>
        <div class="no_msg" v-else>
          <img
            style="width: 88px; height: 92px"
            src="../../../assets/imgs/user/msg_no.png"
            alt=""
          />
          <p>点击消息查看详情内容</p>
        </div>
      </div>
    </div>

    <!-- 右键菜单 -->
    <div
      v-show="ctxVisible"
      class="ctx_menu"
      :style="{ left: ctxX + 'px', top: ctxY + 'px' }"
      @click.stop
    >
      <div
        v-if="ctxItem && isUnread(ctxItem)"
        class="ctx_item"
        @click="ctxMarkRead"
      >
        标为已读
      </div>
      <div class="ctx_item danger" @click="ctxDelete">删除</div>
    </div>
  </div>
</template>

<script>
import {
  messageList,
  messageUnread,
  messageDetail,
  messageRead,
  messageReadAll,
  messageDelete,
} from "@/Api/userMessage";
import { eventBus } from "@/eventBus";

export default {
  name: "Information",
  data() {
    return {
      activeName: "all",
      messageData: [],
      msg_id: null,
      msgData: {},
      queryForm: {
        page: 1,
        size: 10,
        msg_type: "",
      },
      totalCount: 0,
      loading: false,
      loadingMore: false,
      detailLoading: false,
      unreadMap: {
        all: 0,
        system: 0,
        activity: 0,
      },
      ctxVisible: false,
      ctxX: 0,
      ctxY: 0,
      ctxItem: null,
      ctxIndex: -1,
    };
  },
  computed: {
    unreadTotal() {
      return Number(this.unreadMap.all) || 0;
    },
    tabs() {
      return [
        { name: "all", label: "全部", count: this.unreadMap.all },
        { name: "system", label: "系统", count: this.unreadMap.system },
        { name: "activity", label: "活动", count: this.unreadMap.activity },
      ];
    },
    hasMore() {
      return this.messageData.length < this.totalCount;
    },
    detailBlocks() {
      if (this.isRecalled(this.msgData)) return [];
      return this.parseContentBlocks(this.msgData);
    },
    fallbackDetailHtml() {
      const raw =
        this.msgData.message || this.msgData.desc || this.msgData.content || "";
      if (typeof raw === "string") return raw;
      return "";
    },
  },
  created() {
    this.fetchUnread();
    this.fetchList(true);
  },
  mounted() {
    document.addEventListener("click", this.hideContextMenu);
    document.addEventListener("scroll", this.hideContextMenu, true);
    // 公共头部「一键已读」
    eventBus.$on("messageReadAll", this.handleReadAll);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.hideContextMenu);
    document.removeEventListener("scroll", this.hideContextMenu, true);
    eventBus.$off("messageReadAll", this.handleReadAll);
  },
  methods: {
    isUnread(item) {
      if (!item) return false;
      // 约定：0 未读，1 已读
      return item.is_read == 0 || item.is_read === false || item.is_read === "0";
    },
    isRecalled(item) {
      return !!(item && item.is_recalled == 1);
    },
    isDeleted(item) {
      return !!(item && item.is_deleted == 1);
    },
    isMsgLocked(item) {
      // 与小程序一致：仅「已删除」锁定列表；已撤回可点进详情
      return this.isDeleted(item);
    },
    getMsgCategory(item) {
      const t = item.msg_type != null ? item.msg_type : item.type;
      // 约定：1 系统 / 2 活动 / 3 安全或其它；也可按文案兜底
      if (t == 2 || t === "activity" || t === "活动") return "activity";
      if (t == 3 || t === "alert" || t === "安全") return "alert";
      if (t == 4 || t === "success") return "success";
      return "system";
    },
    getMsgIcon(item) {
      const cat = this.getMsgCategory(item);
      if (cat === "activity") return "el-icon-present";
      if (cat === "alert") return "el-icon-warning-outline";
      if (cat === "success") return "el-icon-success";
      return "el-icon-bell";
    },
    getMsgTitle(item) {
      if (!item) return "";
      return (
        item.title ||
        item.name ||
        (this.getMsgCategory(item) === "activity"
          ? "活动通知"
          : "系统消息")
      );
    },
    getDetailTime(item) {
      if (!item) return "";
      if (item._timeText) return item._timeText;
      return this.formatTimeDiff(
        item.create_date ||
          item.create_time ||
          item.created_at ||
          item.ctime ||
          item.time ||
          item.send_time ||
          item.publish_time
      );
    },
    /** 解析 content：支持数组 / JSON 字符串 / 纯文本 */
    parseContentBlocks(item) {
      if (!item) return [];
      let raw =
        item.content != null
          ? item.content
          : item.message != null
          ? item.message
          : item.desc;

      if (raw == null || raw === "") return [];

      if (typeof raw === "string") {
        const trimmed = raw.trim();
        if (
          (trimmed.startsWith("[") && trimmed.endsWith("]")) ||
          (trimmed.startsWith("{") && trimmed.endsWith("}"))
        ) {
          try {
            raw = JSON.parse(trimmed);
          } catch (e) {
            return [{ type: "text", value: raw }];
          }
        } else {
          return [{ type: "text", value: raw }];
        }
      }

      if (Array.isArray(raw)) {
        return raw
          .map((block) => {
            if (block == null) return null;
            if (typeof block === "string") {
              return { type: "text", value: block };
            }
            if (typeof block === "object") {
              const type = (block.type || "text").toLowerCase();
              return {
                type,
                value: block.value != null ? block.value : "",
                url: block.url || "",
              };
            }
            return { type: "text", value: String(block) };
          })
          .filter(Boolean);
      }

      if (typeof raw === "object") {
        const type = (raw.type || "text").toLowerCase();
        return [
          {
            type,
            value: raw.value != null ? raw.value : "",
            url: raw.url || "",
          },
        ];
      }

      return [{ type: "text", value: String(raw) }];
    },
    /** 去 HTML 标签，并只取第一行作为列表预览 */
    toPreviewLine(htmlOrText) {
      if (htmlOrText == null) return "";
      let s = String(htmlOrText);
      // br / 块级标签视为换行，再取首行
      s = s
        .replace(/<\s*br\s*\/?\s*>/gi, "\n")
        .replace(/<\/\s*(p|div|li|h[1-6]|tr)\s*>/gi, "\n")
        .replace(/<[^>]+>/g, "")
        .replace(/\r\n|\r/g, "\n");
      // 解码常见实体
      s = s
        .replace(/&nbsp;/gi, " ")
        .replace(/&lt;/gi, "<")
        .replace(/&gt;/gi, ">")
        .replace(/&amp;/gi, "&")
        .replace(/&quot;/gi, '"');
      const firstLine = s
        .split("\n")
        .map((line) => line.replace(/\s+/g, " ").trim())
        .find((line) => line);
      return firstLine || "";
    },
    getMsgSnippet(item) {
      if (!item) return "";

      // 优先解析 content：取第一个有文本的块的第一行
      const blocks = this.parseContentBlocks(item);
      if (blocks.length) {
        for (const b of blocks) {
          if (b.type === "image") continue;
          const line = this.toPreviewLine(b.value);
          if (line) return line;
        }
        if (blocks.some((b) => b.type === "image")) return "[图片]";
      }

      // 兜底摘要字段
      const fallback = item.summary || item.desc || "";
      if (fallback && typeof fallback === "string") {
        const s = this.toPreviewLine(fallback);
        if (
          s &&
          !s.includes("[object Object]") &&
          !(s.startsWith("[") && s.includes('"type"'))
        ) {
          return s;
        }
      }
      return "";
    },
    formatTimeDiff(targetTime) {
      if (!targetTime) return "";
      const targetDate = new Date(
        typeof targetTime === "number" && targetTime < 1e12
          ? targetTime * 1000
          : targetTime
      );
      if (Number.isNaN(targetDate.getTime())) return String(targetTime);

      const now = new Date();
      const diffMs = now - targetDate;
      if (diffMs < 0) return "刚刚";

      const diffMinutes = Math.floor(diffMs / (1000 * 60));
      const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
      const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

      if (diffDays > 3) {
        const year = targetDate.getFullYear();
        const month = String(targetDate.getMonth() + 1).padStart(2, "0");
        const day = String(targetDate.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
      }
      if (diffDays >= 1) return `${diffDays}天前`;
      if (diffHours >= 1) return `${diffHours}小时前`;
      if (diffMinutes >= 1) return `${diffMinutes}分钟前`;
      return "刚刚";
    },
    normalizeListItem(item) {
      const timeRaw =
        item.create_date ||
        item.create_time ||
        item.created_at ||
        item.ctime ||
        item.time;
      return {
        ...item,
        _timeText: this.formatTimeDiff(timeRaw),
      };
    },
    switchTab(name) {
      if (this.activeName === name) return;
      this.activeName = name;
      this.queryForm.page = 1;
      if (name === "system") {
        this.queryForm.msg_type = 1;
      } else if (name === "activity") {
        this.queryForm.msg_type = 2;
      } else {
        this.queryForm.msg_type = "";
      }
      this.msg_id = null;
      this.msgData = {};
      this.fetchList(true);
    },
    handleScroll(e) {
      const target = e.target;
      if (
        target.scrollTop + target.clientHeight >=
        target.scrollHeight - 20
      ) {
        this.loadMore();
      }
    },
    loadMore() {
      if (this.loading || this.loadingMore || !this.hasMore) return;
      this.queryForm.page += 1;
      this.fetchList(false);
    },
    fetchList(reset) {
      if (reset) {
        this.loading = true;
        this.queryForm.page = 1;
      } else {
        this.loadingMore = true;
      }
      const params = {
        page: this.queryForm.page,
        size: this.queryForm.size,
      };
      if (
        this.queryForm.msg_type !== "" &&
        this.queryForm.msg_type != null
      ) {
        params.msg_type = this.queryForm.msg_type;
      }

      messageList(params)
        .then((res) => {
          const payload = (res.data && res.data.data) || {};
          const list = Array.isArray(payload)
            ? payload
            : payload.data ||
              payload.list ||
              payload.results ||
              payload.records ||
              [];
          const mapped = list.map((item) => this.normalizeListItem(item));
          if (reset || this.queryForm.page === 1) {
            this.messageData = mapped;
          } else {
            this.messageData = [...this.messageData, ...mapped];
          }
          this.totalCount =
            payload.count != null
              ? payload.count
              : payload.total != null
              ? payload.total
              : this.messageData.length;
          this.syncUnreadToHeader();
        })
        .catch((err) => {
          console.log(err);
          if (reset) this.messageData = [];
        })
        .finally(() => {
          this.loading = false;
          this.loadingMore = false;
        });
    },
    pickUnreadNum(...vals) {
      for (let i = 0; i < vals.length; i++) {
        const v = vals[i];
        if (v != null && v !== "") {
          const n = Number(v);
          if (!isNaN(n)) return n;
        }
      }
      return 0;
    },
    syncUnreadToHeader() {
      const listUnread = this.messageData.filter((m) => this.isUnread(m))
        .length;
      const total = Math.max(this.unreadTotal, listUnread);
      eventBus.$emit("newTotal", total);
      this.$emit("newTotal", total);
    },
    fetchUnread() {
      messageUnread()
        .then((res) => {
          const d = (res.data && res.data.data) || {};
          this.unreadMap = {
            all: this.pickUnreadNum(
              d.total,
              d.all,
              d.unread,
              d.unread_count,
              d.count
            ),
            system: this.pickUnreadNum(
              d.system,
              d.system_count,
              d.system_unread
            ),
            activity: this.pickUnreadNum(
              d.activity,
              d.activity_count,
              d.activity_unread
            ),
          };
          this.syncUnreadToHeader();
        })
        .catch((err) => {
          console.log(err);
          this.syncUnreadToHeader();
        });
    },
    changeMsg(item) {
      if (!item || !item.id || this.isMsgLocked(item)) return;
      this.msg_id = item.id;
      this.hideContextMenu();
      this.loadDetail(item);
      if (this.isUnread(item)) {
        this.markRead(item, false);
      }
    },
    loadDetail(item) {
      if (this.isRecalled(item)) {
        this.detailLoading = false;
        this.msgData = this.normalizeListItem({ ...item });
        return;
      }
      this.detailLoading = true;
      messageDetail({ id: item.id })
        .then((res) => {
          const d = (res.data && res.data.data) || {};
          const detail = this.normalizeListItem({ ...item, ...d });
          if (!detail._timeText && item._timeText) {
            detail._timeText = item._timeText;
          }
          this.msgData = detail;
        })
        .catch((err) => {
          console.log(err);
          // 详情失败时用列表项兜底展示
          this.msgData = this.normalizeListItem({ ...item });
        })
        .finally(() => {
          this.detailLoading = false;
        });
    },
    markRead(item, showTip) {
      if (!item || !item.id || !this.isUnread(item)) return Promise.resolve();
      return messageRead({ msg_ids: item.id })
        .then((res) => {
          if (res.data && res.data.error_code == 0) {
            const idx = this.messageData.findIndex((m) => m.id == item.id);
            if (idx > -1) {
              this.$set(this.messageData[idx], "is_read", 1);
            }
            if (this.msgData && this.msgData.id == item.id) {
              this.$set(this.msgData, "is_read", 1);
            }
            this.fetchUnread();
            if (showTip) {
              this.$message.success(res.data.msg || "已标为已读");
            }
          } else {
            this.$message.error((res.data && res.data.msg) || "操作失败");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleReadAll() {
      if (this.unreadTotal <= 0) return;
      messageReadAll()
        .then((res) => {
          if (res.data && res.data.error_code == 0) {
            this.messageData = this.messageData.map((m) => ({
              ...m,
              is_read: 1,
            }));
            if (this.msgData && this.msgData.id) {
              this.$set(this.msgData, "is_read", 1);
            }
            this.unreadMap = { all: 0, system: 0, activity: 0 };
            eventBus.$emit("newTotal", 0);
            this.$emit("newTotal", 0);
            this.$message.success(res.data.msg || "已全部标为已读");
            this.fetchUnread();
          } else {
            this.$message.error((res.data && res.data.msg) || "操作失败");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    openContextMenu(e, item, index) {
      this.ctxItem = item;
      this.ctxIndex = index;
      this.ctxVisible = true;
      this.$nextTick(() => {
        const menuW = 120;
        const menuH = 80;
        let x = e.clientX;
        let y = e.clientY;
        if (x + menuW > window.innerWidth) x = window.innerWidth - menuW - 8;
        if (y + menuH > window.innerHeight) y = window.innerHeight - menuH - 8;
        this.ctxX = x;
        this.ctxY = y;
      });
    },
    hideContextMenu() {
      this.ctxVisible = false;
      this.ctxItem = null;
      this.ctxIndex = -1;
    },
    ctxMarkRead() {
      if (!this.ctxItem || !this.isUnread(this.ctxItem)) {
        this.hideContextMenu();
        return;
      }
      const item = this.ctxItem;
      this.hideContextMenu();
      this.markRead(item, true);
    },
    ctxDelete() {
      if (!this.ctxItem) {
        this.hideContextMenu();
        return;
      }
      const item = this.ctxItem;
      this.hideContextMenu();
      this.$confirm("确认删除该消息？", "提示", {
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          messageDelete({ msg_ids: item.id })
            .then((res) => {
              if (res.data && res.data.error_code == 0) {
                this.messageData = this.messageData.filter(
                  (m) => m.id != item.id
                );
                if (this.msg_id == item.id) {
                  this.msg_id = null;
                  this.msgData = {};
                }
                this.totalCount = Math.max(0, this.totalCount - 1);
                this.fetchUnread();
                this.$message.success(res.data.msg || "删除成功");
              } else {
                this.$message.error((res.data && res.data.msg) || "删除失败");
              }
            })
            .catch((err) => {
              console.log(err);
              this.$message.error("删除接口暂不可用，请确认后端已提供删除能力");
            });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="less" scoped>
.Information {
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: stretch;
  padding: 0;
  background: #fff;
  box-sizing: border-box;
  min-height: calc(100vh - 120px);
}

.msg_css {
  width: 100%;
  display: flex;
  align-items: stretch;
  flex: 1;
  min-height: calc(100vh - 120px);
  border-radius: 0;
  border: none;
  background: #fff;
  overflow: hidden;
}

/* 左侧：约 360px，窄屏可收缩 */
.msg_left {
  display: flex;
  width: 360px;
  max-width: 42%;
  min-width: 280px;
  flex-direction: column;
  align-items: stretch;
  flex-shrink: 0;
  align-self: stretch;
  box-sizing: border-box;
  border-right: 1px solid #e5e5e5;
  background: #fff;
}

.left_tabs {
  display: flex;
  align-items: stretch;
  width: 100%;
  height: 60px;
  border-bottom: 1px solid #e2e8f0;
  box-sizing: border-box;
  flex-shrink: 0;
}

.tab_item {
  position: relative;
  flex: 1 1 0;
  min-width: 56px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
  padding: 8px 12px 12px;
  color: #64748b;
  font-size: 14px;
  font-weight: 500;
  line-height: 22px;
  cursor: pointer;
  user-select: none;
  box-sizing: border-box;

  .tab_label {
    text-align: center;
  }

  &.active {
    color: #0f172a;

    &::after {
      content: "";
      position: absolute;
      left: 16px;
      right: 16px;
      bottom: 0;
      height: 2px;
      background: #0f172a;
      border-radius: 1px;
    }
  }
}

.tab_badge {
  min-width: 16px;
  height: 16px;
  padding: 0 5px;
  border-radius: 9999px;
  background: #f1416c;
  color: #f8fafc;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  text-align: center;
  box-sizing: border-box;
}

.left_list {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 4px;
  padding: 4px;
  flex: 1;
  height: calc(100vh - 140px);
  overflow-x: hidden;
  overflow-y: auto;
  box-sizing: border-box;
}

.left_list::-webkit-scrollbar {
  width: 5px;
}
.left_list::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background-color: #cbd5e1;
}
.left_list::-webkit-scrollbar-track {
  background: transparent;
}

.left_li {
  display: flex;
  padding: 12px 16px;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  cursor: pointer;
  border-radius: 8px;
  background: #fff;
  overflow: hidden;
  transition: background 0.15s;
  box-sizing: border-box;

  &:hover,
  &.is_active_ {
    background: #f8fafc;
  }

  &.is_locked {
    cursor: not-allowed;
    background: #f7f8fa;

    .li_img {
      filter: grayscale(1);
      opacity: 0.45;
      box-shadow: none;
    }

    .tit_text,
    .top_date,
    .li_box_con {
      color: #a3a8b3;
    }

    &:hover {
      background: #f7f8fa;
    }
  }
}

.msg_state {
  flex-shrink: 0;
  padding: 0 6px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  white-space: nowrap;

  &.is_recalled {
    color: #b45309;
    background: #fff7ed;
  }

  &.is_deleted {
    color: #b42318;
    background: #fef3f2;
  }
}

/* 设计稿：32 圆角方标 + 渐变，非圆形 */
.li_img {
  width: 32px;
  height: 32px;
  border-radius: 10.67px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #fff;
  font-size: 15px;
  box-shadow: 0 2.67px 4px -2.67px rgba(244, 63, 94, 0.2),
    0 6.67px 10px -2px rgba(244, 63, 94, 0.2);

  &.icon_activity {
    background: linear-gradient(45deg, #f4cd3f 0%, #f97316 100%);
  }
  &.icon_system {
    background: linear-gradient(45deg, #60a5fa 0%, #2563eb 100%);
    box-shadow: 0 2.67px 4px -2.67px rgba(37, 99, 235, 0.2),
      0 6.67px 10px -2px rgba(37, 99, 235, 0.2);
  }
  &.icon_alert {
    background: linear-gradient(45deg, #fb7185 0%, #f1416c 100%);
  }
  &.icon_success {
    background: linear-gradient(45deg, #86efac 0%, #22c55e 100%);
    box-shadow: 0 2.67px 4px -2.67px rgba(34, 197, 94, 0.2),
      0 6.67px 10px -2px rgba(34, 197, 94, 0.2);
  }
}

.li_box {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  flex: 1 1 0;
  min-width: 0;
}

.li_box_top {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  align-self: stretch;
  gap: 8px;
}

.top_tit {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1 1 0;
  min-width: 0;
  color: #3f4254;
  font-size: 14px;
  font-weight: 500;
  line-height: 22px;

  .tit_text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.unread_dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #f1416c;
  flex-shrink: 0;
}

.top_date {
  color: #737373;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  white-space: nowrap;
  flex-shrink: 0;
}

.li_box_con {
  width: 100%;
  color: #737373;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.list_empty {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  color: #94a3b8;
  font-size: 13px;
}

.list_loading {
  width: 100%;
  padding: 24px 0;
  text-align: center;
  color: #94a3b8;
  font-size: 13px;
}

.msg_right {
  display: flex;
  padding: 24px;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  flex: 1 1 0;
  align-self: stretch;
  min-width: 0;
  background: #fff;
  box-sizing: border-box;
  height: calc(100vh - 120px);
  overflow-x: hidden;
  overflow-y: auto;
}

.msg_right_empty {
  justify-content: center;
}

.right_time {
  text-align: center;
  color: #737373;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  margin-bottom: 4px;
}

/* 设计稿详情卡：标题条按类型着色 */
.right_card {
  display: flex;
  width: 100%;
  max-width: 600px;
  padding: 0;
  flex-direction: column;
  align-items: stretch;
  border-radius: 12px;
  border: 1px solid #e5e5e5;
  background: #fff;
  box-sizing: border-box;
  overflow: hidden;
}

.right_tit {
  text-align: left;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  word-break: break-word;
  padding: 16px 20px;
  color: #006fff;

  &.tit_system {
    background: linear-gradient(90deg, #eef5ff 0%, #e8f1ff 100%);
    color: #006fff;
  }
  &.tit_activity {
    background: linear-gradient(90deg, #fff4e5 0%, #ffe8cc 100%);
    color: #c2410c;
  }
  &.tit_alert {
    background: linear-gradient(90deg, #feeeed 0%, #feeeed 100%);
    color: #f1416c;
  }
  &.tit_success {
    background: #e7fae6;
    color: #12b76a;
  }
}

.right_body {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px 20px 20px;
}

.right_con {
  display: flex;
  flex-direction: column;
  gap: 16px;
  color: #525252;
  font-size: 16px;
  line-height: 24px;
  word-break: break-word;
}

.content_block {
  width: 100%;
}

.content_text {
  margin: 0;
  word-break: break-word;
  color: #171717;
  font-size: 14px;
  line-height: 22px;

  /deep/ p {
    margin: 0 0 8px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  /deep/ img {
    max-width: 100%;
    height: auto;
    border-radius: 12px;
  }
  /deep/ a {
    color: #006fff;
  }
}

.content_img {
  display: block;
  width: 100%;
  max-height: 360px;
  border-radius: 12px;
  object-fit: contain;
  background: #f8fafc;
}

.right_sign {
  align-self: flex-end;
  color: #171717;
  font-size: 14px;
  line-height: 22px;

}

.no_msg {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;

  p {
    color: #94a3b8;
    margin: 0;
  }
}

/* 已撤回详情空状态（对齐小程序 mesDetail） */
.removed_empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  max-width: 600px;
  padding: 120px 24px 48px;
  box-sizing: border-box;
}

.removed_empty__icon-wrap {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: #ebedf0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
}

.removed_empty__icon {
  font-size: 32px;
  color: #969799;
}

.removed_empty__text {
  margin: 0;
  color: #000;
  // font-size: 17px;
  line-height: 24px;
  // font-weight: 600;
  text-align: center;
}

.ctx_menu {
  position: fixed;
  z-index: 3000;
  min-width: 112px;
  padding: 6px 0;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.12);
  border: 1px solid #e5e5e5;
}

.ctx_item {
  padding: 10px 16px;
  font-size: 14px;
  color: #3f4254;
  cursor: pointer;
  line-height: 20px;

  &:hover:not(.disabled) {
    background: #f8fafc;
  }

  &.danger {
    color: #f1416c;
  }

  &.disabled {
    color: #94a3b8;
    cursor: not-allowed;

    &:hover {
      background: transparent;
    }
  }
}

@media (max-width: 960px) {
  .msg_left {
    width: 300px;
    max-width: 46%;
    min-width: 260px;
  }
  .right_tit {
    font-size: 20px;
    line-height: 28px;
  }
  .right_card {
    padding: 20px;
    gap: 20px;
  }
}
</style>
